import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor,HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import { finalize } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
 
@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(public loaderService: NgxSpinnerService) {
    }
 
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.show();
        let  jwttoken = localStorage.getItem('piyushToken');
        req = req.clone({
            setHeaders: {
             'Authorization': `Bearer ${jwttoken}`,
            },
          });
        return next.handle(req).pipe(
            finalize(() => { 
                this.loaderService.hide();
            })
        );
    }
}